import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {Sensor} from 'shared';
import {SensorHistoryRequest} from '../sensor-history-request';
import ArrayStore from 'devextreme/data/array_store';
import {DxDataGridComponent} from 'devextreme-angular';
import {Workbook} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {saveAs} from 'file-saver';
import {DatePipe} from '@angular/common';

@Component({
  selector: 'app-sensor-history-changes',
  templateUrl: './sensor-history-changes.component.html',
  styleUrls: ['./sensor-history-changes.component.scss']
})
export class SensorHistoryChangesComponent implements OnInit {

  @Input()
  sensor: Sensor;

  @Input()
  request: SensorHistoryRequest;

  @Input()
  toolbar: ArrayStore;

  @ViewChild(DxDataGridComponent)
  gridComponent: DxDataGridComponent;

  constructor(private datePipe: DatePipe) {
    this.calculateGroupValue = this.calculateGroupValue.bind(this);
  }

  ngOnInit(): void {
    this.toolbar.insert({
      id: 'export',
      location: 'after',
      widget: 'dxButton',
      locateInMenu: 'auto',
      options: {
        icon: 'export',
        hint: 'Exporter',
        type: 'normal',
        onClick: (e: any) => {
          const workbook = new Workbook();
          const worksheet = workbook.addWorksheet('Remplissage');
          exportDataGrid({
            component: this.gridComponent.instance,
            worksheet
          }).then(() => {
            workbook.xlsx.writeBuffer()
              .then((buffer: BlobPart) => {
                saveAs(new Blob([buffer], {type: 'application/octet-stream'}), 'remplissage.xlsx');
              });
          });
        }
      },
    });
  }

  customizeText(cellInfo) {
    if (cellInfo.value <= 0) {
      return `<sapn style="color:#ce312c">-${cellInfo.valueText}</sapn>`;
    } else {
      return `<sapn style="color:#5cb85c">+${cellInfo.valueText}</sapn>`;
    }
  }

  calculateGroupValue(rowData) {
    return this.datePipe.transform(rowData.time, 'fullDate');
  }
}
